import { LayoutGroup } from "framer-motion";
import { useId } from "react";

import { cx } from "@/utils";

export default function SidebarSection({ className, ...props }) {
  let id = useId();

  return (
    <LayoutGroup id={id}>
      <div
        {...props}
        data-slot="section"
        className={cx("flex flex-col gap-0.5", className)}
      />
    </LayoutGroup>
  );
}
